import { Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const AlbumCard = ({ album }) => {
  const navigate = useNavigate();

  return (
    <div 
      className="glass-card p-4 card-hover group cursor-pointer"
      onClick={() => navigate(`/album/${album.id}`)}
      data-testid={`album-card-${album.id}`}
    >
      <div className="relative aspect-square mb-4 rounded-lg overflow-hidden">
        <img 
          src={album.cover_url} 
          alt={album.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-purple-500 flex items-center justify-center shadow-lg">
            <Play className="w-6 h-6 text-white ml-1" />
          </div>
        </div>
      </div>

      <h3 className="font-semibold text-white truncate mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        {album.title}
      </h3>
      <p className="text-sm text-gray-400 truncate mb-2">{album.artist}</p>
      <p className="text-sm text-gray-500 line-clamp-2 mb-3">{album.description}</p>

      <div className="flex items-center justify-between">
        <span className="text-purple-400 font-medium subheading">${album.price.toFixed(2)}</span>
        <span className="text-xs text-gray-500">{album.release_date}</span>
      </div>
    </div>
  );
};
